module.exports = __webpack_public_path__ + "static/img/hair_13.28f1a0c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/defis/img/hair/thumbnail/hair_13.png
// module id = I0xq
// module chunks = 0